import * as l from "react";
import { useState as J } from "react";
var b = function() {
  return b = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var c in n) Object.prototype.hasOwnProperty.call(n, c) && (t[c] = n[c]);
    }
    return t;
  }, b.apply(this, arguments);
};
function Z(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function ee(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, a = t.length, c; r < a; r++)
    (c || !(r in t)) && (c || (c = Array.prototype.slice.call(t, 0, r)), c[r] = t[r]);
  return e.concat(c || Array.prototype.slice.call(t));
}
var x = "right-scroll-bar-position", B = "width-before-scroll-bar", te = "with-scroll-bars-hidden", re = "--removed-body-scroll-bar-size";
function W(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function ne(e, t) {
  var n = J(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var a = n.value;
          a !== r && (n.value = r, n.callback(r, a));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var ae = typeof window < "u" ? l.useLayoutEffect : l.useEffect, Y = /* @__PURE__ */ new WeakMap();
function oe(e, t) {
  var n = ne(null, function(r) {
    return e.forEach(function(a) {
      return W(a, r);
    });
  });
  return ae(function() {
    var r = Y.get(n);
    if (r) {
      var a = new Set(r), c = new Set(e), u = n.current;
      a.forEach(function(i) {
        c.has(i) || W(i, null);
      }), c.forEach(function(i) {
        a.has(i) || W(i, u);
      });
    }
    Y.set(n, e);
  }, [e]), n;
}
function ce(e) {
  return e;
}
function ie(e, t) {
  t === void 0 && (t = ce);
  var n = [], r = !1, a = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(c) {
      var u = t(c, r);
      return n.push(u), function() {
        n = n.filter(function(i) {
          return i !== u;
        });
      };
    },
    assignSyncMedium: function(c) {
      for (r = !0; n.length; ) {
        var u = n;
        n = [], u.forEach(c);
      }
      n = {
        push: function(i) {
          return c(i);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(c) {
      r = !0;
      var u = [];
      if (n.length) {
        var i = n;
        n = [], i.forEach(c), u = n;
      }
      var m = function() {
        var v = u;
        u = [], v.forEach(c);
      }, g = function() {
        return Promise.resolve().then(m);
      };
      g(), n = {
        push: function(v) {
          u.push(v), g();
        },
        filter: function(v) {
          return u = u.filter(v), n;
        }
      };
    }
  };
  return a;
}
function le(e) {
  e === void 0 && (e = {});
  var t = ie(null);
  return t.options = b({ async: !0, ssr: !1 }, e), t;
}
var G = function(e) {
  var t = e.sideCar, n = Z(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return l.createElement(r, b({}, n));
};
G.isSideCarExport = !0;
function ue(e, t) {
  return e.useMedium(t), G;
}
var Q = le(), I = function() {
}, A = l.forwardRef(function(e, t) {
  var n = l.useRef(null), r = l.useState({
    onScrollCapture: I,
    onWheelCapture: I,
    onTouchMoveCapture: I
  }), a = r[0], c = r[1], u = e.forwardProps, i = e.children, m = e.className, g = e.removeScrollBar, v = e.enabled, w = e.shards, R = e.sideCar, C = e.noRelative, E = e.noIsolation, o = e.inert, f = e.allowPinchZoom, h = e.as, s = h === void 0 ? "div" : h, y = e.gapMode, S = Z(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), d = R, k = oe([n, t]), p = b(b({}, S), a);
  return l.createElement(
    l.Fragment,
    null,
    v && l.createElement(d, { sideCar: Q, removeScrollBar: g, shards: w, noRelative: C, noIsolation: E, inert: o, setCallbacks: c, allowPinchZoom: !!f, lockRef: n, gapMode: y }),
    u ? l.cloneElement(l.Children.only(i), b(b({}, p), { ref: k })) : l.createElement(s, b({}, p, { className: m, ref: k }), i)
  );
});
A.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
A.classNames = {
  fullWidth: B,
  zeroRight: x
};
var fe = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function se() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = fe();
  return t && e.setAttribute("nonce", t), e;
}
function de(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function ve(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var he = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = se()) && (de(t, n), ve(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, me = function() {
  var e = he();
  return function(t, n) {
    l.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, U = function() {
  var e = me(), t = function(n) {
    var r = n.styles, a = n.dynamic;
    return e(r, a), null;
  };
  return t;
}, ge = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, j = function(e) {
  return parseInt(e || "", 10) || 0;
}, ye = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [j(n), j(r), j(a)];
}, be = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return ge;
  var t = ye(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Se = U(), T = "data-scroll-locked", pe = function(e, t, n, r) {
  var a = e.left, c = e.top, u = e.right, i = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(te, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(i, "px ").concat(r, `;
  }
  body[`).concat(T, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(c, `px;
    padding-right: `).concat(u, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(i, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(x, ` {
    right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(B, ` {
    margin-right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(x, " .").concat(x, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(B, " .").concat(B, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(T, `] {
    `).concat(re, ": ").concat(i, `px;
  }
`);
}, V = function() {
  var e = parseInt(document.body.getAttribute(T) || "0", 10);
  return isFinite(e) ? e : 0;
}, we = function() {
  l.useEffect(function() {
    return document.body.setAttribute(T, (V() + 1).toString()), function() {
      var e = V() - 1;
      e <= 0 ? document.body.removeAttribute(T) : document.body.setAttribute(T, e.toString());
    };
  }, []);
}, Ce = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, a = r === void 0 ? "margin" : r;
  we();
  var c = l.useMemo(function() {
    return be(a);
  }, [a]);
  return l.createElement(Se, { styles: pe(c, !t, a, n ? "" : "!important") });
}, D = !1;
if (typeof window < "u")
  try {
    var N = Object.defineProperty({}, "passive", {
      get: function() {
        return D = !0, !0;
      }
    });
    window.addEventListener("test", N, N), window.removeEventListener("test", N, N);
  } catch {
    D = !1;
  }
var P = D ? { passive: !1 } : !1, Ee = function(e) {
  return e.tagName === "TEXTAREA";
}, K = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Ee(e) && n[t] === "visible")
  );
}, Re = function(e) {
  return K(e, "overflowY");
}, ke = function(e) {
  return K(e, "overflowX");
}, H = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var a = $(e, r);
    if (a) {
      var c = q(e, r), u = c[1], i = c[2];
      if (u > i)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Pe = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Oe = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, $ = function(e, t) {
  return e === "v" ? Re(t) : ke(t);
}, q = function(e, t) {
  return e === "v" ? Pe(t) : Oe(t);
}, Te = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Me = function(e, t, n, r, a) {
  var c = Te(e, window.getComputedStyle(t).direction), u = c * r, i = n.target, m = t.contains(i), g = !1, v = u > 0, w = 0, R = 0;
  do {
    if (!i)
      break;
    var C = q(e, i), E = C[0], o = C[1], f = C[2], h = o - f - c * E;
    (E || h) && $(e, i) && (w += h, R += E);
    var s = i.parentNode;
    i = s && s.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? s.host : s;
  } while (
    // portaled content
    !m && i !== document.body || // self content
    m && (t.contains(i) || t === i)
  );
  return (v && Math.abs(w) < 1 || !v && Math.abs(R) < 1) && (g = !0), g;
}, L = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, F = function(e) {
  return [e.deltaX, e.deltaY];
}, _ = function(e) {
  return e && "current" in e ? e.current : e;
}, Ne = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Le = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, xe = 0, O = [];
function Be(e) {
  var t = l.useRef([]), n = l.useRef([0, 0]), r = l.useRef(), a = l.useState(xe++)[0], c = l.useState(U)[0], u = l.useRef(e);
  l.useEffect(function() {
    u.current = e;
  }, [e]), l.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var o = ee([e.lockRef.current], (e.shards || []).map(_), !0).filter(Boolean);
      return o.forEach(function(f) {
        return f.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), o.forEach(function(f) {
          return f.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = l.useCallback(function(o, f) {
    if ("touches" in o && o.touches.length === 2 || o.type === "wheel" && o.ctrlKey)
      return !u.current.allowPinchZoom;
    var h = L(o), s = n.current, y = "deltaX" in o ? o.deltaX : s[0] - h[0], S = "deltaY" in o ? o.deltaY : s[1] - h[1], d, k = o.target, p = Math.abs(y) > Math.abs(S) ? "h" : "v";
    if ("touches" in o && p === "h" && k.type === "range")
      return !1;
    var M = H(p, k);
    if (!M)
      return !0;
    if (M ? d = p : (d = p === "v" ? "h" : "v", M = H(p, k)), !M)
      return !1;
    if (!r.current && "changedTouches" in o && (y || S) && (r.current = d), !d)
      return !0;
    var X = r.current || d;
    return Me(X, f, o, X === "h" ? y : S);
  }, []), m = l.useCallback(function(o) {
    var f = o;
    if (!(!O.length || O[O.length - 1] !== c)) {
      var h = "deltaY" in f ? F(f) : L(f), s = t.current.filter(function(d) {
        return d.name === f.type && (d.target === f.target || f.target === d.shadowParent) && Ne(d.delta, h);
      })[0];
      if (s && s.should) {
        f.cancelable && f.preventDefault();
        return;
      }
      if (!s) {
        var y = (u.current.shards || []).map(_).filter(Boolean).filter(function(d) {
          return d.contains(f.target);
        }), S = y.length > 0 ? i(f, y[0]) : !u.current.noIsolation;
        S && f.cancelable && f.preventDefault();
      }
    }
  }, []), g = l.useCallback(function(o, f, h, s) {
    var y = { name: o, delta: f, target: h, should: s, shadowParent: Ae(h) };
    t.current.push(y), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== y;
      });
    }, 1);
  }, []), v = l.useCallback(function(o) {
    n.current = L(o), r.current = void 0;
  }, []), w = l.useCallback(function(o) {
    g(o.type, F(o), o.target, i(o, e.lockRef.current));
  }, []), R = l.useCallback(function(o) {
    g(o.type, L(o), o.target, i(o, e.lockRef.current));
  }, []);
  l.useEffect(function() {
    return O.push(c), e.setCallbacks({
      onScrollCapture: w,
      onWheelCapture: w,
      onTouchMoveCapture: R
    }), document.addEventListener("wheel", m, P), document.addEventListener("touchmove", m, P), document.addEventListener("touchstart", v, P), function() {
      O = O.filter(function(o) {
        return o !== c;
      }), document.removeEventListener("wheel", m, P), document.removeEventListener("touchmove", m, P), document.removeEventListener("touchstart", v, P);
    };
  }, []);
  var C = e.removeScrollBar, E = e.inert;
  return l.createElement(
    l.Fragment,
    null,
    E ? l.createElement(c, { styles: Le(a) }) : null,
    C ? l.createElement(Ce, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function Ae(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const We = ue(Q, Be);
var Ie = l.forwardRef(function(e, t) {
  return l.createElement(A, b({}, e, { ref: t, sideCar: We }));
});
Ie.classNames = A.classNames;
function z() {
  return z = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, z.apply(null, arguments);
}
function De(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
export {
  Ie as R,
  De as _,
  z as a
};
